module.exports = __webpack_public_path__ + "img/logo.ae024a59.svg";